import React from 'react';
import LetterTemplateForm from './components/LetterTemplateForm';

function LetterTemplateFormPage() {
  return <LetterTemplateForm />;
}

export default LetterTemplateFormPage;
